import PipCharacter from "./PipCharacter";
import { usePip } from "./PipContext";

function PipFaceIcon({ size = 28 }) {
  return <PipCharacter size={size} state="found" />;
}

export default function PipEgg() {
  const {
    activeSpawn,
    foundState,
    toast,
    cooldown,
    outfit,
    handleFound,
    hideGamesPip,
  } = usePip();

  if (!activeSpawn && !toast) return null;

  const isGames = Boolean(activeSpawn?.isGames || activeSpawn?.alwaysVisible);
  const onCooldown = cooldown.onCooldown;
  const clickable = Boolean(
    activeSpawn
    && !foundState
    && (isGames || !onCooldown)
  );

  const handleClick = () => {
    if (!activeSpawn || foundState) return;
    // Games: click hides Pip for this visit (no credit claim).
    if (isGames) {
      hideGamesPip();
      return;
    }
    if (onCooldown) return;
    handleFound(activeSpawn.categoryId);
  };

  const pos = activeSpawn?.position || {};
  const style = {
    position: "fixed",
    bottom: pos.bottom || (isGames ? "120px" : "100px"),
    right: pos.right || "20px",
    left: pos.left,
    top: pos.top,
    zIndex: 9990,
  };

  const state = foundState ? "found" : activeSpawn?.state || "idle";
  const size = isGames ? 100 : 52;

  return (
    <>
      {activeSpawn && (
        <button
          type="button"
          className={`pip-egg-btn${foundState ? " pip-egg-btn--found" : ""}`}
          style={style}
          onClick={handleClick}
          disabled={!clickable}
          aria-label={isGames ? "Hide Pip" : (foundState ? "Pip found!" : "Find Pip!")}
        >
          <PipCharacter
            size={size}
            state={state}
            peek={activeSpawn.peek || "A"}
            outfit={outfit}
            interactive={clickable}
          />
          {!foundState && !isGames && !onCooldown && (
            <span className="pip-egg-hint">psst…</span>
          )}
        </button>
      )}

      {toast && (
        <div className="pip-egg-toast" role="status">
          <span className="pip-egg-toast-icon"><PipFaceIcon size={24} /></span>
          {toast}
        </div>
      )}
    </>
  );
}
